import {
  useJobRefinementState,
  RESUME_FORM,
  SHOW_SUMMARY,
  FORM_COMPLETED,
} from './JobRefinement.reducer';
import type { RequestOrigin } from './types';
import {
  JOB_REFINEMENT_INTERACTIONS,
  trackJobRefinementForm,
} from './JobRefinementTracking';

export const useJobRefinement = () => {
  const { state, dispatch } = useJobRefinementState();
  const { form, isFormCompleted } = state;

  const isValidForm = Object.keys(form).length > 0;

  const openJobSummary = (origin: RequestOrigin, companyId?: number) => {
    if (!isFormCompleted) {
      trackJobRefinementForm(JOB_REFINEMENT_INTERACTIONS.OPEN, state, {
        origin,
      });
      return dispatch({
        type: RESUME_FORM,
        payload: { origin, companyId },
      });
    }

    trackJobRefinementForm(JOB_REFINEMENT_INTERACTIONS.SUMMARY, state, {
      origin,
    });
    return dispatch({ type: SHOW_SUMMARY, payload: { origin, companyId } });
  };

  const openRaqEntryPointJob = (origin: RequestOrigin, companyId?: number) => {
    if (isFormCompleted) {
      return dispatch({ type: FORM_COMPLETED, isInRaqEntryPointMode: true });
    }

    trackJobRefinementForm(JOB_REFINEMENT_INTERACTIONS.OPEN, state, {
      origin,
    });
    return dispatch({
      type: RESUME_FORM,
      payload: { origin, companyId },
    });
  };

  return { isValidForm, openRaqEntryPointJob, openJobSummary };
};
